/* eslint-disable react/no-unused-state */
/* eslint-disable no-return-assign */
/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { DateTime, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import CustomDateTimeSettingsForm from './CustomDateTime.settingsForm';
import getLocalParams from '../localizationCustoms';
import { getCurrentESThour, getDatetimeEST, checkIfCurrentDateIsTheDayAfterInEst, getDatetimeESTsummingHours } from '../../../utils/common/dates/estDateTime';

const CustomDateTime = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(v) {
    const { onChange, component, language } = this.props || null;
    const { useReviewLabel, reviewLabel, label } = component || null;
    const dateObj = {
      value: v,
      review: { label: useReviewLabel ? reviewLabel : label, value: new Date(v).toLocaleString(`${language}-CA`, { dateStyle: 'long' }) },
    };
    onChange(dateObj);
  }

  render() {
    const { value } = this.state || null;
    const { component, disabled } = this.props || null;
    const { hideCustomLabel, label, tooltip, minDateCheckbox, maxDateCheckbox, placeholder, tooltipTitle } = component || null;
    const minDateValue = new Date(new Date().setFullYear(new Date().getFullYear() - 10));
    let maxDateValue;
    if (checkIfCurrentDateIsTheDayAfterInEst() || getCurrentESThour() >= 22) {
      maxDateValue = new Date(getDatetimeEST());
    } else {
      maxDateValue = getDatetimeESTsummingHours(2);
    }

    return (
      <>
        {!hideCustomLabel && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <label className="label-question">
              <FormattedMessage id={label} defaultMessage={label} />
            </label>
            {tooltip !== '' && (
              <Tooltip id="datetime_tooltip" primary title={tooltipTitle}>
                <FormattedMessage id={tooltip} defaultMessage={tooltip} />
              </Tooltip>
            )}
          </div>
        )}
        {component && (
          <DateTime
            secondary
            time
            selectYear
            placeholder={placeholder}
            minDate={minDateCheckbox ? minDateValue : null}
            maxDate={maxDateCheckbox ? maxDateValue : null}
            value={value && value.value ? new Date(value.value) : null}
            onChange={(v) => this.onChangeHandler(v)}
            shouldCloseOnSelect={false}
            disabled={disabled}
          />
        )}
      </>
    );
  }
};

export default class DateTimeComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom DateTime',
      icon: 'calendar',
      group: 'advanced',
      documentation: '',
      weight: -10,
      schema: DateTimeComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */

  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customdatetime',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomDateTimeSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  async attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomDateTime
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
          language={localParams?.lang || 'en'}
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  async detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
